import { PERMISSION_LABELS, PermissionLevel } from "./userAccessReport";

const PERMISSION_BALL_COLOR: Record<PermissionLevel, string> = {
  none: "#94a3b8",
  partial: "#d97706",
  all: "#059669",
};

export function Check({ on }: { on: boolean }) {
  return on ? (
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      role="img"
      aria-label="Yes"
      focusable="false"
      style={{ display: "inline-block", verticalAlign: "middle" }}
    >
      <path
        d="M13.5 4.5 6.5 11.5 2.5 7.5"
        fill="none"
        stroke="#059669"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <span
      aria-label="No"
      style={{
        display: "inline-block",
        width: "10px",
        height: "2px",
        backgroundColor: "#cbd5e1",
        verticalAlign: "middle",
      }}
    />
  );
}

export function HarveyBall({
  level,
  decorative = false,
}: {
  level: PermissionLevel;
  decorative?: boolean;
}) {
  const color = PERMISSION_BALL_COLOR[level];
  const a11y = decorative
    ? { "aria-hidden": true as const }
    : { role: "img" as const, "aria-label": PERMISSION_LABELS[level] };
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 16 16"
      focusable="false"
      {...a11y}
      style={{ display: "inline-block", verticalAlign: "middle" }}
    >
      {level === "all" ? (
        <circle cx="8" cy="8" r="6" fill={color} />
      ) : level === "partial" ? (
        <>
          <circle
            cx="8"
            cy="8"
            r="6"
            fill="none"
            stroke={color}
            strokeWidth="1.6"
          />
          <path d="M8 2 A6 6 0 0 0 8 14 Z" fill={color} />
        </>
      ) : (
        <circle
          cx="8"
          cy="8"
          r="6"
          fill="none"
          stroke={color}
          strokeWidth="1.6"
        />
      )}
    </svg>
  );
}
